/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompanyBrand { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    acronym: string;
}

